import ITag from '../../../components/ITag'

function SecNavWrapper({socials, showSocials = true}) {

    //alert(JSON.stringify(socials))

    let supported = []
    supported["facebook"] = "https://facebook.com/";
    supported["web"] = ""
    supported["twitter"] = "https://twitter.com/";
    supported["discord"] = "";
    supported["matrix"] = "";
    supported["instagram"] = "https://instagram.com/";

    // Don't render if socials are hidden or not present
    if (!socials || !showSocials) { return null; }

    let sMap = Object.entries(socials);

    return (
        <div style={{zIndex: "15", background: "rgba(32,32,32,0.6)"}}
             className="col-auto px-1 border-radius-md my-sm-auto ms-auto me-sm-0 mt-0">
            <div className="border-0 ps-0 pb-0">
                <strong className="text-light text-sm">Socials:</strong> &nbsp;
                {sMap.map((item) => (
                    <a
                        key={item[0]}
                        className={"btn btn-" + item[0] + " btn-simple mb-0 ps-1 pe-2 py-0"}
                        href={supported[item[0]] + item[1]}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <ITag ClassName={"fab fa-" + item[0] + " fa-lg"} aria-hidden="true"/>
                    </a>
                ))}
            </div>
        </div>
    )
}

export default SecNavWrapper
